// 环境变量配置
const env = process.env.REACT_APP_ENV || "development";

// 基础配置
const baseConfig = {
  // 所有环境通用配置
  appName: "UpToDate临床顾问临床思维大赛",
  version: "1.0.0",
  // 投稿截止日期，格式 yyyy-MM-dd HH:mm:ss（各环境可按需覆盖）
  submissionDeadline: "2026-10-11 23:59:59",
};

// 特定环境配置
const envConfigs = {
  development: {
    apiBaseUrl: "https://api.uptodatecontest.wolterskluwer.cn",
    envName: "开发环境",
    debug: true,
    mobileSite: "http://223.87.216.215:18122",
  },
  test: {
    apiBaseUrl: "http://223.87.216.215:18119/api",
    envName: "测试环境",
    debug: true,
    mobileSite: "http://223.87.216.215:18122",
  },
  production: {
    apiBaseUrl: "https://api.uptodatecontest.wolterskluwer.cn",
    envName: "生产环境",
    debug: false,
    mobileSite: "https://m.uptodatecontest.wolterskluwer.cn",
  },
};

// 合并当前环境配置与基础配置
const config = {
  ...baseConfig,
  ...envConfigs[env],
  env,
};

export default config;
